import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define a type for the slice state
interface EventFilterState {
  showEventFilter: boolean,
  selectedEvent: string
}

// Define the initial state using that type
const initialState: EventFilterState = {
    showEventFilter: false,
    selectedEvent: ''
}

export const eventFilterSlice = createSlice({
    name: 'eventFilter',
    initialState,
    reducers: {
      setEventFilter: (state, action: PayloadAction<boolean>) => {
        state.showEventFilter = action.payload;
      },
      setSelectedEvent: (state, action: PayloadAction<string>) => {
        state.selectedEvent = action.payload;
      },
    },
  });
  
  export const { setEventFilter, setSelectedEvent } = eventFilterSlice.actions;
  
  export default eventFilterSlice.reducer;